import { BaseAuditableEntity } from '@domain';

export class QuoteTaxeEntity extends BaseAuditableEntity {
    companyId: string;
    name: string;
    description: string;

    // * Modo da taxa: `fixed` (valor em dinheiro) ou `percentage` (percentual, ex.: 20 = 20%)
    mode: 'fixed' | 'percentage';

    // * Valor da taxa: dinheiro quando `fixed`, percentual quando `percentage`
    price: number;

    // * Informa somente dentro do documento se o item foi inserido através do catálogo
    catalogItemId: string;
}
